import * as React from 'react';

const ChevronBackground: React.FC = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1440 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      className="absolute inset-0 w-full h-full"
    >
      <g opacity="0.7">
        <rect
          opacity="0.1"
          x="-48.5293"
          y="71.252"
          width="1525.91"
          height="1017.28"
          fill="url(#paint0_linear_9097_178252)"
        />
        <rect
          opacity="0.1"
          x="-48.5293"
          y="71.252"
          width="1525.91"
          height="1017.28"
          fill="#FAFAFA"
        />
        <path
          opacity="0.6"
          d="M232.095 289.952L571.745 -84.7979H393.98L206.627 119.775C150.558 182.198 94.1229 244.224 52.3134 290.091L417.753 693.273H595.688L232.095 289.952Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M136.761 972.579L-14.5657 1139.54L64.6355 1139.54L148.108 1048.4C173.089 1020.59 198.233 992.952 216.861 972.517L54.0435 792.883L-25.2331 792.883L136.761 972.579Z"
          fill="white"
        />
        <path
          opacity="0.04"
          d="M1202.38 783.153L584.553 101.479H907.909L1248.71 473.599C1350.69 587.147 1453.35 699.972 1529.4 783.405L864.665 1516.8H541L1202.38 783.153Z"
          fill="#676767"
        />
        <path
          opacity="0.1"
          d="M1383.66 216.293L1310.89 135.999H1348.97L1389.12 179.831C1401.13 193.205 1413.22 206.495 1422.18 216.322L1343.88 302.708H1305.76L1383.66 216.293Z"
          fill="#676767"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9097_178252"
          x1="690.404"
          y1="158.463"
          x2="695.941"
          y2="1088.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#959595" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChevronBackground;
